<template>
  <div class="loader">
      <div class="loader-div">
        <div class="main-loader-div">
          <img src="@/assets/loader.svg" class="loader-image" alt="loader" />
        </div>
        <p class="loading"> Please wait a moment</p>
      </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
  .loader {
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.5);
  }
  .loader-div {
    width: 20%;
    background-color: #ffffff;
    margin: 18% 40%;
    padding: 40px;
    border-radius: 13px;
  }
  .main-loader-div {
    margin: auto;
    text-align: center;
  }
  p {
    color: #000000;
    font-size: 0.8rem;
    text-align: center;
  }
  /* loading dots */
  .loading:after {
    content: ' .';
    animation: dots 1s steps(5, end) infinite;}

  @keyframes dots {
    0%, 20% {
      color: #000000;
      text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0);
    }
    40% {
      color: #000000;
      text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0);
    }
    60% {
      text-shadow: .25em 0 0 #000000, .5em 0 0 rgba(0,0,0,0);}
    80%, 100% {
      text-shadow: .25em 0 0 #000000, .5em 0 0 #000000;
    }
  }
  @media only screen and (min-width: 320px) {
    .loader-div {
      width: 65%;
      margin: 60% auto;
    }
  }
  @media only screen and (min-width: 768px) {
    .loader-div {
      width: 40%;
      margin: 40% auto;
    }
  }
  @media only screen and (min-width: 1024px) {
    .loader-div {
      width: 30%;
      margin: 30% auto;
    }
  }
  @media only screen and (min-width: 1200px) {
    .loader-div {
      width: 20%;
      margin: 19% 40%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/Loader.vue